import moment from 'moment/moment'
import {
    ValidationResult,
} from 'app/types/form.types'
import dateMask from 'app/utils/date/dateMask'
import {
    ForecastCreateRawData,
} from '../ShortTermForecastCsvUpload.types'

export const DATE_REGEX = /^\d{1,2}\.\d{2}\.\d{4}$/
const DOT_REGEX = /\./g
const SPECIAL_CHAR_REGEX = /[!@#$%^&*(),?":{}|<>\-/\\ ]/g

export const validateForecastCsvHeaders = (
    data: ForecastCreateRawData[],
    l: (key: string) => string,
): ValidationResult => {
    const headers = Object.keys(data[0])
    const hasHeadersWithSpecialChars = headers.some((header) => {
        return SPECIAL_CHAR_REGEX.test(header)
    })

    if (hasHeadersWithSpecialChars) {
        return [l('FORECAST_HEADERS_NO_SPECIAL_CHARS')]
    }

    const hasDateHeaders = headers.some((header) => {
        return DATE_REGEX.test(header)
    })

    if (!hasDateHeaders) {
        return [l('FORECAST_HEADERS_NO_DATE_COLUMNS')]
    }

    const hasNotValidDatesInDateHeaders = headers.some((header) => {
        return DOT_REGEX.test(header) && !moment(header, dateMask).isValid()
    })

    if (hasNotValidDatesInDateHeaders) {
        return [l('FORECAST_HEADERS_INVALID_DATES')]
    }
    return true
}
